import { Div } from 'alkali'
export const FilterArrow = Div('.filter-arrow', [
	Div('.end-segment'),
	Div('.left-triangle'),
])
export const FilterArrows = Div('.filter-arrows', [
	Div('.start-segment'),
	Div('.middle-segment'),
	FilterArrow('.characteristics-arrow'),
	FilterArrow('.interventions-arrow'),
	FilterArrow('.outcomes-arrow'),
])

export const QuestionArrow = Div('.question-arrow', [
	Div('.segment'),
	Div('.top-triangle'),
])
